// extracted by mini-css-extract-plugin
export var pageFooter = "styles-module--pageFooter--9_5O9";
export var footerWrapper = "styles-module--footerWrapper--2dGzY";
export var column1 = "styles-module--column1--1ynre";
export var column2 = "styles-module--column2--YraII";
export var column3 = "styles-module--column3--18Yod";
export var clientFooter = "styles-module--clientFooter--1oYqs";
export var line = "styles-module--line--2IXK5";
export var logo = "styles-module--logo--2n5it";
export var hideMobile = "styles-module--hideMobile--iiLvD";